/* ARDAS — interactions */
document.addEventListener('DOMContentLoaded', () => {

  /* Mark the current page in the nav + menu (active-state colour) */
  (() => {
    const here = (location.pathname.split('/').pop() || 'index.html').toLowerCase();
    document.querySelectorAll('.nav__links a, .menu a').forEach(a => {
      const href = (a.getAttribute('href') || '').split('/').pop().toLowerCase();
      if (href === here) a.setAttribute('aria-current', 'page');
    });
  })();

  /* Scroll reveal */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal, .draw').forEach(el => io.observe(el));

  /* Nav: transparent at the very top, opaque (solid bg) the instant we scroll.
     This is what stops page content merging with the fixed bar at every scroll
     position. Works for the main nav and the bespoke world's nav. */
  const nav = document.querySelector('.nav, .bsp-nav');
  if (nav && nav.dataset.scrollSolid !== 'false') {
    /* --- Adaptive nav tone (replaces mix-blend-mode) -------------------------
       While the header is transparent, measure the luminance of the hero behind
       the fixed bar and set .nav--light / .nav--dark so inactive text contrasts
       (dark over light heroes, white over dark). The active link stays a true
       fixed #C89841 in CSS - no blend to invert it. */
    const parseColor = (str) => {
      const m = str && str.match(/rgba?\(([^)]+)\)/);
      if (!m) return null;
      const p = m[1].split(',').map(s => parseFloat(s));
      return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
    };
    const relLum = ({ r, g, b }) => {
      const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
      return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
    };
    // Sample a few points behind the nav; resolve the first opaque background /
    // tone signal walking up the DOM. Media (img/video) heroes default to dark.
    const heroTone = () => {
      const y = Math.max(8, (nav.offsetHeight || 80) / 2);
      const xs = [innerWidth * 0.15, innerWidth * 0.5, innerWidth * 0.85];
      const prevPE = nav.style.pointerEvents; nav.style.pointerEvents = 'none';
      const scores = xs.map((x) => {
        let el = document.elementFromPoint(Math.round(x), Math.round(y));
        let steps = 0;
        while (el && el !== document.documentElement && steps < 14) {
          if (el.dataset && el.dataset.navTone) return el.dataset.navTone === 'light' ? 1 : 0;
          const c = parseColor(getComputedStyle(el).backgroundColor);
          if (c && c.a > 0.2) return relLum(c) > 0.55 ? 1 : 0;
          // NOTE: do NOT early-return "dark" for img/video here - that forced
          // inactive nav white on light hero pages whose hero has a media element
          // in front of a light section background. Keep walking up to the hero
          // section's real background colour (concrete=light, charcoal=dark).
          el = el.parentElement; steps++;
        }
        return 0; // nothing found -> dark default
      });
      nav.style.pointerEvents = prevPE;
      const light = scores.reduce((a, b) => a + b, 0) / scores.length;
      return light >= 0.5 ? 'light' : 'dark';
    };
    const applyTone = () => {
      if (nav.classList.contains('solid')) {
        nav.classList.remove('nav--light', 'nav--dark'); // solid state handles its own colour
        return;
      }
      const tone = heroTone();
      nav.classList.toggle('nav--light', tone === 'light');
      nav.classList.toggle('nav--dark', tone === 'dark');
    };
    const onScroll = () => {
      const past = window.scrollY > 60;
      nav.classList.toggle('solid', past);    // opaque background + readable text
      nav.classList.toggle('scrolled', past); // bespoke nav hook
      nav.classList.toggle('condensed', past);
      applyTone();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', applyTone, { passive: true });
    window.addEventListener('load', applyTone);
    onScroll();
  }

  /* Mobile menu */
  const burger = document.querySelector('.nav__burger');
  const menu = document.querySelector('.menu');
  if (burger && menu) {
    // One place that sets the whole open/close state: drawer, burger X + ivory
    // icon, nav bar transparency (so the icon/logo read on the dark drawer), the
    // aria flag, and body scroll lock. `nav` is the fixed header resolved above.
    burger.setAttribute('aria-expanded', 'false');
    const setMenu = (open) => {
      menu.classList.toggle('open', open);
      burger.classList.toggle('is-open', open);
      if (nav) nav.classList.toggle('is-menu-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger.addEventListener('click', () => setMenu(!menu.classList.contains('open')));
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
  }

  /* Choice chips (single-select per group). Groups marked [data-multi]
     (e.g. booking "Interested In") are owned by booking.js, which handles
     independent multi-select there; skip them so this single-select handler
     does not clear their sibling selections. */
  document.querySelectorAll('[data-chips]:not([data-multi])').forEach(group => {
    group.querySelectorAll('.chip').forEach(chip => {
      chip.addEventListener('click', () => {
        group.querySelectorAll('.chip').forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        const input = group.querySelector('input[type=hidden]');
        if (input) input.value = chip.textContent.trim();
      });
    });
  });

  /* Form submit -> graceful confirmation (prototype) */
  document.querySelectorAll('form[data-capture]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const done = form.querySelector('[data-done]');
      form.style.transition = 'opacity .5s'; form.style.opacity = '0';
      setTimeout(() => { form.style.display = 'none'; if (done) { done.hidden = false; requestAnimationFrame(()=>done.classList.add('in')); } }, 500);
    });
  });

  /* Subtle parallax on hero media */
  const px = document.querySelectorAll('[data-parallax]');
  if (px.length) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      px.forEach(el => { el.style.transform = `translateY(${y * (el.dataset.parallax || 0.12)}px)`; });
    }, { passive: true });
  }

  /* Image fallback — keep the atelier monochrome look even if a source fails */
  document.querySelectorAll('img[data-seed]').forEach(img => {
    img.addEventListener('error', function handler() {
      img.removeEventListener('error', handler);
      const s = img.dataset.seed, w = img.dataset.w || 900, h = img.dataset.h || 1100;
      img.src = `https://picsum.photos/seed/${s}/${w}/${h}?grayscale`;
    });
  });

  /* Year */
  document.querySelectorAll('[data-year]').forEach(el => el.textContent = new Date().getFullYear());
});
